import { ActionType, IRecentColleagueInfo } from "./model";

export const updateRecentColleaguesList = (
  recentColleagues: IRecentColleagueInfo[] | null,
  loading: boolean
) => ({
  type: ActionType.UPDATE_RECENT_COLLEAGUES,
  data: { workers: recentColleagues, loading },
});
